import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxMaskPipe } from 'ngx-mask';
import { ApplyAclPipe } from './apply-acl.pipe';
import { BNAccountTypePipe } from './bn-account-type.pipe';
import { ErrorKeyPipe } from './error-key.pipe';
import { FilesizePipe } from './file-size.pipe';
import { MoneyPipe } from './money.pipe';
import { OpenTextLanguagePipe } from './opentext-language.pipe';
import { PermissionLetterPipe } from './permission-type.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SelectBusinessFilterPipe } from './select-business-filter.pipe';
import { SelectFilterPipe } from './select-filter.pipe';
import { SortMetadataByKeyPipe, SortMetadataByValuePipe } from './sort-metadata.pipe';
import { SortProgramsListByUid } from './sort-programs.pipe';
import { TransformDatePipe } from './transform-date.pipe';

@NgModule({
  declarations: [SelectFilterPipe,
                TransformDatePipe,
                BNAccountTypePipe,
                ApplyAclPipe,
                FilesizePipe,
                PermissionLetterPipe,
                OpenTextLanguagePipe,
                SafeHtmlPipe,
                ErrorKeyPipe,
                SelectBusinessFilterPipe,
                MoneyPipe,
                SortMetadataByKeyPipe,
                SortMetadataByValuePipe,
                SortProgramsListByUid
              ],
  imports: [
    CommonModule
  ],
  providers: [
    DatePipe,
    DecimalPipe,
    NgxMaskPipe,
    MoneyPipe
  ],
  exports: [SelectFilterPipe,
            PermissionLetterPipe,
            BNAccountTypePipe,
            TransformDatePipe,
            FilesizePipe,
            ApplyAclPipe,
            OpenTextLanguagePipe,
            SafeHtmlPipe,
            ErrorKeyPipe,
            SelectBusinessFilterPipe,
            MoneyPipe,
            SortMetadataByKeyPipe,
            SortMetadataByValuePipe,
            SortProgramsListByUid
          ]
})
export class PipesModule { }
